import { getGaGeoLabel } from './getGaGeoLabel';
import { getRegionId } from './getRegionId';
import { IApplicationState } from '../../types/redux';
import { MOSCOW_AND_MO_IDS } from '../../constants/region';

export function getAnalyticsRegionId(state: IApplicationState): number | string | null {
  const regionId = getRegionId(state);
  if (!regionId) {
    return null;
  }

  if (MOSCOW_AND_MO_IDS.includes(regionId)) {
    return getGaGeoLabel(state);
  }

  return regionId;
}
